import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

function Dashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
          <div className="bg-black flex flex-col gap-4 p-6 md:p-10 min-h-screen">
            <div className="flex flex-1 items-center justify-center">
              <div className="w-full text-white">
              
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography variant="h3" gutterBottom fontWeight={700}>
        Dreamville 2026
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} mt={4}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ px: 5, py: 3, fontSize: 22, fontWeight: 600 }}
          onClick={() => navigate('/main')}
        >
          Map
        </Button>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          sx={{ px: 5, py: 3, fontSize: 22, fontWeight: 600 }}
          onClick={() => navigate('/data-view')}
        >
          Overview
        </Button>
      </Stack>
      <div className='bottom-2.5 left-5 absolute' >
      <Button
        variant="contained"
        color=""
        startIcon={<LogoutIcon />}
        sx={{ mt: 4, fontWeight: 600 }}
        onClick={handleLogout}
      >
        Log Out
      </Button>
      </div>
    </Box>
    </div>
            </div>
          </div>
          <div className="bg-muted relative hidden lg:block">
            <img
              src="../camping.jpg"
              alt="Festival camping field with tents and blue sky"
              className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.5] dark:grayscale-[0.75]"
            />
          </div>
        </div>
  );
}

export default Dashboard;
